import React, { useEffect, useState } from 'react';
import { requestJson } from '../api';
import LayoutViewer from '../LayoutViewer';
import { PageHeader, Button, Surface, Tabs, Skeleton, EmptyState, Badge } from '../ui';
import { openPlanning } from './workspace';
export default function Today({
  canPlan
}) {
  const [tab, setTab] = useState(canPlan ? 'today' : 'map'),
    [data, setData] = useState(null),
    [error, setError] = useState(''),
    [revision, setRevision] = useState(0);
  useEffect(() => { setTab(canPlan ? 'today' : 'map'); }, [canPlan]);
  useEffect(() => {
    if (!canPlan) return;
    let alive = true;
    setError('');
    requestJson('/planning/timeline').then(d => {
      if (alive) setData(d);
    }).catch(e => {
      if (alive) setError(e.message);
    });
    return () => {
      alive = false;
    };
  }, [canPlan, revision]);
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  const jobs = data?.jobs || [],
    segments = (data?.segments || []).filter(s => s.start_time < end.getTime() / 1000 && s.end_time > start.getTime() / 1000).sort((a, b) => a.start_time - b.start_time);
  const problems = [...(data?.conflicts || []), ...(data?.gaps || [])].filter(p => p.start_time < end.getTime() / 1000 && p.end_time > start.getTime() / 1000);
  return <section className="ws-page"><PageHeader title="Heute" description="Tagesgeschäft, Planung und Lager im Blick." /><Tabs label="Tagesübersicht" value={tab} onChange={setTab} items={[...(canPlan ? [{
      value: 'today',
      label: 'Tagesgeschäft'
    }] : []), {
      value: 'map',
      label: 'Lagerbelegung'
    }]} />
 {tab === 'map' || !canPlan ? <div className="ws-map"><LayoutViewer title="Aktuelle Lagerbelegung" /></div> : error ? <EmptyState action={<Button onClick={() => setRevision(x => x + 1)}>Erneut laden</Button>}>{error}</EmptyState> : !data ? <Skeleton /> : <>
 <div className="ws-today-summary"><Surface><small>Vorgänge heute</small><strong>{segments.length}</strong></Surface><Surface><small>Konflikte & Lücken heute</small><strong>{problems.length}</strong></Surface><Surface><small>Ungeplante Jobs insgesamt</small><strong>{jobs.filter(j => j.planning_quality === 'UNPLANNED').length}</strong></Surface></div>
 <div className="ws-today-grid"><Surface><h2>Tagesablauf</h2>{segments.length ? segments.map(s => {
            const job = jobs.find(j => Number(j.id) === Number(s.job_id));
            return <button className="ws-agenda-row" key={s.id} disabled={!job} onClick={() => openPlanning({
              ...job,
              dispo_start: s.start_time
            })}><time>{new Date(s.start_time * 1000).toLocaleTimeString('de-DE', {
                  hour: '2-digit',
                  minute: '2-digit'
                })}</time><span><strong>{job?.display_name || job?.name || 'Job'}</strong><small>{job?.customer || 'Ohne Kunde'}</small></span><Badge>{{
                  PACKEN: 'Packen',
                  PACKED: 'Gepackt',
                  STORAGE: 'Lager',
                  LOADING: 'Einladen',
                  EMPTY_CASES: 'Leergut',
                  RETURN_FULL: 'Retoure',
                  EVENT: 'Veranstaltung',
                  BLOCKED: 'Gesperrt'
                }[s.status] || s.status}</Badge></button>;
          }) : <EmptyState>Heute sind keine Vorgänge geplant.</EmptyState>}</Surface>
 <Surface><h2>Handlungsbedarf</h2>{problems.map((p, i) => {
            const job = jobs.find(j => Number(j.id) === Number(p.job_id || p.jobIds?.[0]));
            return <div className="ws-problem" key={i}><strong>{p.message || 'Planungslücke'}</strong>{job && <Button onClick={() => openPlanning({
                ...job,
                dispo_start: p.start_time
              })}>{job.display_name || job.name} öffnen</Button>}</div>;
          })}{jobs.filter(j => j.planning_quality === 'UNPLANNED').map(j => <div className="ws-problem" key={'j' + j.id}><span>{j.display_name || j.name}</span><Button onClick={() => openPlanning(j)}>Planen</Button></div>)}{!problems.length && !jobs.some(j => j.planning_quality === 'UNPLANNED') && <EmptyState>Keine offenen Planungshinweise.</EmptyState>}</Surface></div></>}
 </section>;
}
